export default __webpack_public_path__ + "static/media/research.34a73411.jpg";